import { render, staticRenderFns } from "./VcaCurrentAnalysis.vue?vue&type=template&id=a3240e80&scoped=true"
import script from "./VcaCurrentAnalysis.vue?vue&type=script&lang=ts"
export * from "./VcaCurrentAnalysis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3240e80",
  null
  
)

export default component.exports